import { render, staticRenderFns } from "./logmanagement.vue?vue&type=template&id=45448d0a&scoped=true&"
import script from "./logmanagement.vue?vue&type=script&lang=js&"
export * from "./logmanagement.vue?vue&type=script&lang=js&"
import style0 from "./logmanagement.vue?vue&type=style&index=0&id=45448d0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45448d0a",
  null
  
)

export default component.exports